import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  styleUrls: ['./categoria.component.css']
})
export class CategoriaControlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
